import { PipeTransform, Pipe } from '@angular/core'

import { UtilityService } from '@core/services/utility.service'

@Pipe({
  name: 'macAddress',
  standalone: false,
})
export class MacAddressPipe implements PipeTransform {
  constructor(private readonly utilityService: UtilityService) {}

  transform(value: string): string {
    return this.utilityService.toMacAddress(value)
  }
}
